import {UPDATE_PHOTO} from "../actions/updatePhoto";

export default function(state = "", {type, payload}) {
    switch (type) {
        case UPDATE_PHOTO:
            return payload;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/admin/components/editor/reducers/photo.js